export const identityConstants = {
    transalationGroup: "_identity",
    token: "token",
    refreshToken: "refreshToken",
    permissions: "permissions",
    disabledClass: "mm-disabled",
    noClickClass: "no-click",
    identityApiRoute: "api/_identity"
}
